import { ApiResponse } from '@/models/ApiResponse';
import { ReportFile } from '@/models/ReportFile';
import { GenericResponse } from '@/types/downloadReports';

import { createAsyncAction } from 'typesafe-actions';

export const saveUserWidgetDealContingentActions = createAsyncAction(
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/request',
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/success',
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/failure',
)<void, GenericResponse, string>();

export const runDealContingentActions = createAsyncAction(
  'DEAL_CONTINGENT/runDealContingent/request',
  'DEAL_CONTINGENT/runDealContingent/success',
  'DEAL_CONTINGENT/runDealContingent/failure',
)<void, ApiResponse<ReportFile>, string>();
